<div id="start">
  <div class="collage">
    <div class="wrapper">
      <div
        *ngFor="let vino of vini; let idx = index"
        class="vino-item"
        (click)="dettaglioVino(vino)"
      >
        <div class="vino__container lis-relative">
          <img
            src="{{ vino.imgsrc }}"
            class="img-fluid img-vino"
            alt="Immagine vino {{ vino.nome }}"
            title="Immagine vino {{ vino.nome }}"
          />
          <div class="nome-vino">
            <span *ngIf="vino.qta" class="qta">x{{ vino.qta }}</span>
            {{ vino.nome | titlecase }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
